import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalClose,
  ModalFooter,
  Icon,
} from '@repo/ui/components'
import { Button } from '@repo/ui/components'
import { useTranslate, MessagesKeys } from '@repo/shared/hooks'

export interface ICity {
  value: string
  label?: string
  labelKey?: string
}

interface CityDrawerProps {
  open: boolean
  value: string
  onChange: (value: string) => void
  onSelectNeighborhood: () => void
  onClose: () => void
  items: ICity[]
}

export const CityDrawer = ({
  items,
  open,
  value,
  onChange,
  onSelectNeighborhood,
  onClose,
}: CityDrawerProps) => {
  const { t } = useTranslate()

  return (
    <Modal open={open} onOpenChange={onClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle className='text-center'>
            {t('filters_city_title' as MessagesKeys)}
          </ModalTitle>
          <ModalClose />
        </ModalHeader>
        <div className='flex max-h-[228px] overflow-y-auto flex-col gap-md py-md'>
          {items.map((city) => (
            <Button
              key={city.value}
              variant={value === city.value ? 'ghost' : 'transparent'}
              className='justify-between [&_svg]:fill-unset active:[&_svg]:fill-unset'
              width='full'
              onClick={() => onChange(city.value)}
            >
              <span className='flex items-center gap-xs'>
                {value === city.value ? (
                  <Icon
                    name='SelectionIndicator'
                    color='fill-unset'
                    size='sm'
                  />
                ) : (
                  <span className='w-5 h-5' />
                )}
                {city.labelKey ? t(city.labelKey as MessagesKeys) : city.label}
              </span>
              {value === city.value && city.value !== 'all' && (
                <Button
                  size='sm'
                  variant='ghost'
                  onClick={onSelectNeighborhood}
                  className='ml-xs'
                  asChild
                >
                  {t('filters_city_select_neighborhood' as MessagesKeys)}
                </Button>
              )}
            </Button>
          ))}
        </div>
        <ModalFooter>
          <Button onClick={onClose} className='w-full' variant='fill'>
            {t('filters_apply')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
